import {ReelState} from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import {TimeCheckPoints} from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import {StateHandler} from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import {Presentation} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGEngineManager} from "../../engine/WGEngineManager";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WildEvents} from "../features/nudge/WildNudgePresentation";
import {WarriorFeatureEvents} from "../features/warriorpayfeature/WarriorPayfeatureView";
import {WarriorGraveyardGameModuleConfig} from "../../WarriorGraveyardGameModuleConfig";
import {Speedster} from "../../debug/Speedster";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {WGEngineController} from "../../engine/WGEngineController";
import {SoundManager} from "../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../WGSoundConfig";
import {WGParsedGameData} from "../../server/data/WGParsedGameData";
import {WGParsedInitData} from "../../server/data/WGParsedInitData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WGGameConfig} from "../../WGGameConfig";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";


/** Using a seperated StateHandler to ForceTrigg the presentation without it's internal StateSystem.
 * Reason is that the InternalState system is depended on the data that get's recieved from server.
 * So when we trigger a new BET, no data has been recieved yet, but we still want to play this.
 */

/**
 *  Note that If you want any data to be parsed for this presentation, Use "CheckForActivation(data:any)".
 *  But the data will mostly be parsed during or when the presentation have already started.
 *  If you want to do some funnyStuff before the spin, Use the EndPresentation function and define the
 *  corresponding presentation to play something before this presentation starts.
 */
class ReelSpinStartState extends StateHandler {
    public static readonly START: string = "start";
    public static readonly DONE: string = "done";
}

export class ReelStartPresentation extends Presentation {

    private _currentMode: string = "";
    protected state: ReelSpinStartState = new ReelSpinStartState(ReelSpinStartState.DONE);

    public initialization(): void {
        const speedHack: Speedster = new Speedster();
    }

    public isActive(): boolean {
        return !WGEngineManager.isPlaying && this.state.equal(ReelSpinStartState.DONE);
    }

    public preStart(): void {
        // Tells the keypad that we are starting the spins are going to start-> enables the quickstop quicker. (The keypad-quickstop have an 1 sec delay before it enables);
        EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED));

        for (let i: number = 0; i < WGEngineManager.AllReels.length; i++) {
            // added this check to only create start when is not sticky wild present
            if (!WarriorGraveyardGameModuleConfig.stickWildView._lockedReels[i]) {
                if (!WGEngineManager.AllReels[i].state.isSpinning) WGEngineManager.AllReels[i].createStart(false);
            }
        }
    }

    public setParsedInitData(data: WGParsedInitData): void {
        this._currentMode = data.mode;
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._currentMode = data.mode;
    }

    public getPresentation(): void {
        TimeCheckPoints.setCheckPoint("Bet");
        WGEngineManager.onBeforeSpinStart();
        this.normalStart();
        this.state.set(ReelSpinStartState.START);
    }

    protected normalStart(): void {
        let delay: number = 0;
        let startDuration: number = 0;
        for (let reel:number = 0; reel < WGEngineManager.AllReels.length; reel++) {
            const rc: WGEngineController = WGEngineManager.getReel(reel);
            if (WarriorGraveyardGameModuleConfig.stickWildView._lockedReels[reel]) {
                continue;
            }
            this.pTimeline.add([
                () => rc.startReel(),
                () => rc.changeAlpha(0.24, rc.getStartDuration()),
            ], delay);

            if (reel > 0 && reel < 5) {
                this.pTimeline.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(WildEvents.SPIN_WILD_MULTIPLIER_WITH_SYMBOL, reel));
                }, delay);
            }
            this.pTimeline.add(() => {
                EventHandler.dispatchEvent(new GameEvent(WarriorFeatureEvents.SPIN_AWAY_ALIVE_SYMBOL_ANIM, reel));
            }, delay);

            delay += rc.startDelay();

            // Get the longest StartTime to be added on the total delay between reels.
            if (rc.getPlayTime() > startDuration)
                startDuration = rc.getPlayTime();
            if (startDuration < GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.START) startDuration = GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.START;
        }

        // sound effect on reel spin start only for fs #124
        if (WGGameConfig.CURRENT_GAME_MODE_BEFORE_SPIN_START === GameMode.FREESPIN) {
            SoundManager.playSoundEffect(WGSoundConfig.instance.SPIN_START_FS);
            // to play wild animation on sticky wild whenn spin start in fs # 291
            for (let i = 0; i < WarriorGraveyardGameModuleConfig.stickWildView._lockingWildAnimationOnReels.length; i++) {
                if (WarriorGraveyardGameModuleConfig.stickWildView._lockingWildAnimationOnReels[i].visible) {
                    WarriorGraveyardGameModuleConfig.stackAnimationPlayer.playWildStackAnimation(i + 1, "_idle");
                }
            }
        } else {
            WarriorGraveyardGameModuleConfig.stickWildView.hideAlllockingReelAnimation();
        }

        // to play reel spinning sound
        SoundManager.playSoundEffect(WGSoundConfig.instance.REELS_SPINNING, 10000);
        this.pTimeline.to(this, delay + startDuration, {});
    }

    // Checks if any reels are still starting.
    public promiseSync(): boolean {
        return WGEngineManager.findFirstReelWithState(ReelState.START) == -1;
    }

    public stopPresentation(): void {
        this.state.set(ReelSpinStartState.DONE);
        WGEngineManager.isPlaying = true;
    }
}